import script from "./vchannelSpreadLink.vue?vue&type=script&setup=true&lang=js"
export * from "./vchannelSpreadLink.vue?vue&type=script&setup=true&lang=js"

import "./vchannelSpreadLink.vue?vue&type=style&index=0&id=6b2b03b3&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2b03b3"]])

export default __exports__